import Footer from './footer'
import Header from './header'
import style from './style.module.css'
import { ReactComponent as InspireBg } from 'assets/icon-inspire-bg.svg'

const Layout = ({ event, children }) => {

    return (
        <>
            <div className={style.layout}>
                <InspireBg className={'position-fixed z-n1 '} style={{ top: '50%', left: '50%', width: 'max(100vw, 100vh)', height: 'max(100vw, 100vh)', transformOrigin: 'center', transform: 'translate(-50%, -50%) scale(1.1)'}} />
                <Header event={event} />
                <div className={style.content}>
                    {children}
                </div>
                <Footer />
            </div>
        </>
    )

}

export default Layout